import * as Yup from 'yup';
import zxcvbn from 'zxcvbn';

Yup.addMethod(
  Yup.string,
  'passwordStrength',
  function (
    errorMessage = 'The password does not meet our minimum password strength requirements.'
  ) {
    return this.test('passwordStrength', errorMessage, function test(password) {
      const { path, createError } = this;
      const evaluation = zxcvbn(password || '');
      const {
        feedback: { warning },
        score
      } = evaluation;

      if (score < 2) {
        let customErrorMessage = errorMessage;
        if (warning) {
          customErrorMessage = `The password does not meet our strength requirements: ${warning}`;
        }
        return createError({ path, message: customErrorMessage });
      }

      return true;
    });
  }
);

export default Yup;
